import React from 'react'
import { isMobile } from 'react-device-detect'
import { OrdersContext } from 'contexts/OrdersContext'
import _ from 'lodash'
import {
  DcSwitch,
  PixelDiv,
  PixelFactoryContext,
  PixelFlexBox,
  PixelModal,
  PixelText,
  Section,
  SectionContent,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs-compat'
import styled from 'styled-components'

import { del, get, post } from 'utils/api-routes.util'
import { SettingsIcon } from 'utils/icons/icon'

import { ICommunicationConfig } from '../SMSSubecription'

import IVRSetting from './IVRSetting'
import { IPixelFactory } from '../../../../../../decl.d'

export interface IEvent {
  id: number
  event_code: string
  event_name: string
  is_active: boolean
  template: string
  communication_type: string
  is_subscribed: boolean
}
export interface IModifyEvent {
  order_received: IEvent
  order_confirmed: IEvent
  order_dispatched: IEvent
  order_awaiting: IEvent
  order_cancelled: IEvent
  order_out_of_stock: IEvent
  order_delivered: IEvent
  order_refused: IEvent
}

export interface CreatedAt {
  date: Date
  timezone_type: number
  timezone: string
}

export interface IPlan {
  id: number
  service: Service
  plan_name: string
  plan_cost: number | null
  is_active: boolean
}

export interface Service {
  id: number
  service_name: string
  service_description: string
  is_active: boolean
}
interface IProps {
  setActiveTabs: (_: string) => void
  communicationConfig: ICommunicationConfig
  setCommunicationConfig: (_: ICommunicationConfig) => void
}
const EventSubscriptions = ({
  setActiveTabs,
  communicationConfig,
  setCommunicationConfig,
}: IProps) => {
  const [showSettingPopup, setShowSettingPopup] = React.useState(false)
  const { showSuccess, showFailure, showLoader, hideLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const { state } = React.useContext(OrdersContext)
  const [events, setEvents] = React.useState<IModifyEvent[]>([])
  const enrollConfigRef = React.useRef<any>(null)
  React.useEffect(() => {
    if (events?.length == 0) getAllSmsEvents()
  }, [])

  const enrollAutoNotify = (value) => {
    showLoader(enrollConfigRef)
    post('/communication/config/auto-notify', {
      auto_notify_enrollment: value,
    }).subscribe((res: AjaxResponse<ICommunicationConfig | any>) => {
      const data = res.response?.data
      if (data) {
        setCommunicationConfig({
          ...communicationConfig,
          config: {
            REMAINING_BALANCE: Number(data.balance_available || 0),
            CURRENT_PLAN: data.current_plan.plan.plan_name,
            REMAINING_CREDITS_FOR_PLAN: Number(
              data.current_plan.remaining_credit || 0,
            ),
            EXPIRY_DATE: data.current_plan.expiry_date.date,
            SERVICE_NAME: data.current_plan.plan.service.service_name,
            SUBSCRIBED_AT: data.current_plan.created_at.date,
            CREDIT_CONSUMED: data.current_plan.credit_consumed || 0,
            AUTO_NOTIFY: data.auto_notify ?? false,
          },
          current_plan: data?.current_plan?.plan,
          remaining_credits: data.current_plan.remaining_credit || 0,
          auto_status_update: data?.auto_status_update,
          ivr_cancel_status: data?.ivr_cancel_status,
          ivr_confirm_status: data?.ivr_confirm_status,
        })
        hideLoader(enrollConfigRef)
        showSuccess(
          value
            ? 'Successfully enrolled to auto notify'
            : 'Successfully unsubscribed to auto notify',
        )
      }
    })
  }

  const formatData = (data: Event[]): { [key: string]: Event[] }[] => {
    const transformedData: { [key: string]: Event[] }[] = []

    data.forEach((event) => {
      const eventCode = event?.event_code
      // const existingIndex = event

      transformedData.push({ [eventCode]: [event] })
    })

    return transformedData
  }
  const getAllSmsEvents = () => {
    showLoader(enrollConfigRef)
    get('/communication/events').subscribe((res: any) => {
      hideLoader(enrollConfigRef)
      if (res.response.data) {
        setEvents(formatData(res.response.data))
      }
    })
  }

  const enrollEvent = (event) => {
    showLoader(enrollConfigRef)
    if (event.is_subscribed) {
      post('/communication/events/subscribe', {
        event_id: event.event_id,
      }).subscribe((res: any) => {
        hideLoader(enrollConfigRef)
        if (res.response.data) {
          setEvents(formatData(res.response.data))
        } else {
          showFailure(res.response.error)
        }
      })
    } else {
      del(`/communication/events/${event.event_id}`).subscribe((res: any) => {
        hideLoader(enrollConfigRef)
        if (res.response.data) {
          setEvents(formatData(res.response.data))
        } else {
          showFailure(res.response.error)
        }
      })
    }
  }
  return (
    <PixelFlexBox>
      <Section style={{ padding: '0' }} isMobile={isMobile}>
        <SectionContent
          style={{ boxShadow: 'none', padding: '0' }}
          isMobile={isMobile}
          className="sms-settings"
          ref={enrollConfigRef}
        >
          <PixelDiv style={{ border: '1px solid #e6e6e6' }}>
            <PixelFlexBox
              style={{ width: '100%', borderBottom: '1px solid #e6e6e6' }}
              // padding="10px"
              gap="15px"
              alignItems="center"
            >
              <PixelDiv style={{ height: '100%' }} width="auto">
                {' '}
                <PixelFlexBox padding="10px" justifyContent="flex-end">
                  <DcSwitch
                    className={''}
                    value={communicationConfig.config.AUTO_NOTIFY}
                    onChange={(e) => enrollAutoNotify(e.target.checked)}
                    checked={communicationConfig.config.AUTO_NOTIFY}
                    disabled={
                      !communicationConfig.config.REMAINING_BALANCE &&
                      !communicationConfig.config.REMAINING_CREDITS_FOR_PLAN
                    }
                    label={communicationConfig.config.AUTO_NOTIFY}
                  />
                </PixelFlexBox>
              </PixelDiv>

              <PixelDiv
                style={{
                  borderRight: '1px solid #e0e0e0',
                  height: '100%',
                  padding: '15px',
                }}
                width="20%"
              >
                <PixelText
                  textSize="20px"
                  style={{ fontWeight: 'bold' }}
                  customColor="#2f3c4d"
                  margin="0px 0px 0px 0px"
                >
                  Subscribe to Events
                </PixelText>
              </PixelDiv>
              <PixelDiv width="74%">
                <PixelText
                  textSize="20px"
                  style={{ fontWeight: 'bold' }}
                  customColor="#2f3c4d"
                  margin="0px 0px 0px 0px"
                >
                  Enroll to Auto Notify
                </PixelText>
              </PixelDiv>
            </PixelFlexBox>
            <Events
              className={
                !communicationConfig.config.AUTO_NOTIFY ? 'disabled' : ''
              }
            >
              {events.length &&
                events.map((event: IModifyEvent, i: number) => (
                  <PixelFlexBox
                    alignItems="center"
                    gap="15px"
                    style={{
                      borderBottom: '1px solid #e6e6e6',
                    }}
                    key={i}
                    height={'auto'}
                  >
                    <PixelDiv
                      style={{
                        // borderRight: ' 1px solid #e0e0e0',
                        height: '100%',
                      }}
                      width="auto"
                    >
                      {event[Object.keys(event)[0]].map(
                        (singleEvent: IEvent, i: number) => (
                          <PixelFlexBox
                            key={i}
                            padding="10px "
                            justifyContent="flex-end"
                          >
                            <DcSwitch
                              className={''}
                              value={singleEvent.is_subscribed}
                              disabled={
                                singleEvent.event_code === 'order_awaiting' ||
                                singleEvent.event_code === 'order_refused'
                              }
                              onChange={(e) => {
                                if (
                                  singleEvent.communication_type === 'call' &&
                                  e.target.checked
                                ) {
                                  if (
                                    !communicationConfig?.ivr_cancel_status &&
                                    !communicationConfig?.ivr_confirm_status
                                  ) {
                                    setShowSettingPopup(true)
                                  } else {
                                    enrollEvent({
                                      is_subscribed: e.target.checked,
                                      event_id: singleEvent.id,
                                    })
                                  }
                                } else {
                                  enrollEvent({
                                    is_subscribed: e.target.checked,
                                    event_id: singleEvent.id,
                                  })
                                }
                              }}
                              checked={singleEvent.is_subscribed}
                              label={singleEvent.is_subscribed}
                            />
                          </PixelFlexBox>
                        ),
                      )}
                    </PixelDiv>
                    <PixelDiv
                      style={{
                        borderRight: '1px solid #e0e0e0',
                        height: '100%',
                        padding: '17px',
                      }}
                      width="20%"
                    >
                      <PixelText textSize="19px" style={{ fontWeight: '700' }}>
                        {Object.keys(event)[0].replace(/_/g, ' ')}
                      </PixelText>
                    </PixelDiv>
                    <PixelDiv width="74%">
                      {/* Mapping through single events here */}
                      {event[Object.keys(event)[0]].map(
                        (singleEvent: IEvent, i: number) => (
                          <PixelFlexBox
                            key={i}
                            flexDirection="column"
                            gap="10px"
                          >
                            {singleEvent.communication_type === 'sms' ? (
                              <PixelText
                                textSize="17px"
                                customColor="#545454;"
                                style={{ fontWeight: '400' }}
                                key={singleEvent.id}
                              >
                                <span
                                  style={{ color: 'black', fontWeight: 500 }}
                                >
                                  SMS:{' '}
                                </span>{' '}
                                {singleEvent.template?.replace(
                                  '{brand_name}',
                                  `${state.tenantInfo.business_name}`,
                                )}
                              </PixelText>
                            ) : (
                              <PixelFlexBox
                                flexDirection="row"
                                alignItems="center"
                              >
                                <span
                                  style={{ color: 'black', fontWeight: 500 }}
                                >
                                  Call(IVR):{' '}
                                </span>{' '}
                                &nbsp;&nbsp;
                                {/* <audio src={image} controls>
                                  Your browser does not support the audio
                                  element.
                                </audio> */}
                                <SettingsIcon
                                  tooltip={'Auto Status Update Settings'}
                                  onClick={() => setActiveTabs('ivrSettings')}
                                  size={18}
                                />
                              </PixelFlexBox>
                            )}
                          </PixelFlexBox>
                        ),
                      )}
                    </PixelDiv>
                  </PixelFlexBox>
                ))}
            </Events>
          </PixelDiv>
        </SectionContent>
      </Section>
      {showSettingPopup && (
        <PixelModal
          overflow={true}
          title={'IVR Auto Update Settings'}
          handleClose={() => setShowSettingPopup(false)}
          show={showSettingPopup}
        >
          {showSettingPopup && (
            <IVRSetting
              data={{
                auto_status_update: communicationConfig.auto_status_update,
                ivr_cancel_status: communicationConfig.ivr_cancel_status,
                ivr_confirm_status: communicationConfig.ivr_confirm_status,
                auto_notify: communicationConfig?.config?.AUTO_NOTIFY,
                is_retry: communicationConfig?.is_retry,
              }}
              origin={'popup'}
              handleClose={(action, data) => {
                if (action === 'success') {
                  const callEvents = _.flatMap(events, (event) => {
                    return _.flatMap(event, (subEvents) => {
                      return subEvents.filter(
                        (subEvent) => subEvent.communication_type === 'call',
                      )
                    })
                  })
                  enrollEvent({
                    is_subscribed: true,
                    event_id: callEvents[0].id,
                  })
                }
                setShowSettingPopup(false)
                if (data) {
                  setCommunicationConfig({
                    ...communicationConfig,
                    auto_status_update: data?.auto_status_update,
                    ivr_cancel_status: data?.ivr_cancel_status,
                    ivr_confirm_status: data?.ivr_confirm_status,
                  })
                }
              }}
            />
          )}
        </PixelModal>
      )}
    </PixelFlexBox>
  )
}
const Events = styled.div`
  /* margin-top: 30px; */
  position: relative;
  /* border: 1px solid #e6e6e6; */
  &.disabled {
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #f2f2f2;
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`

export default EventSubscriptions
